var map = {
	"./development": "./src/config/development.js",
	"./development.js": "./src/config/development.js",
	"./kubes": "./src/config/kubes.js",
	"./kubes.js": "./src/config/kubes.js",
	"./production": "./src/config/production.js",
	"./production.js": "./src/config/production.js",
	"./staging": "./src/config/staging.js",
	"./staging.js": "./src/config/staging.js",
	"./staging2": "./src/config/staging2.js",
	"./staging2.js": "./src/config/staging2.js",
	"./test": "./src/config/test.js",
	"./test.js": "./src/config/test.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config sync recursive ^\\.\\/.*$";